import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renameEstimate from '../../actions/renameEstimate';
import RenameEstimateButton from './RenameEstimateButton';
import { create } from '../../helpers/validationFunctionFactory';

const mapStateToProps = ({ estimateBuilder }) => {
  const { estimates } = estimateBuilder.entities;
  const { selectedEstimate } = estimateBuilder.uiState;
  const nameList = estimates.allIds
    .filter(givenId => givenId !== selectedEstimate)
    .map(givenId => estimates.byId[givenId].name);

  const validateFunction = create(nameList, 50, 'Estimate name');

  return {
    validate: validateFunction,
    defaultName: estimates.byId[selectedEstimate].name,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ renameEstimate }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RenameEstimateButton);
